import React from 'react';
import PropTypes from 'prop-types';

export default class Pagination extends React.Component {
  static defaultProps = {
    /**response.options */
    total: 0,
    count: 0,
    limit: 30,
    pageNo: 1,
    start: 0,
    totalPage: 0,
    pages: [],
    showNext: false,
    showPrevious: false,

    /**response.info */
    pagesize: 30,
    showpage: [10, 50, 100],
    startPageNo: 1
  };

  static propTypes = {
    startPageNo: PropTypes.number.isRequired,
    totalPage: PropTypes.number.isRequired,
    showPrevious: PropTypes.bool.isRequired,
    showNext: PropTypes.bool.isRequired,
    pageNo: PropTypes.number.isRequired,
    goPage: PropTypes.func.isRequired
  };
}

